/* eslint eqeqeq: "off" */
import React, { Component, createRef } from 'react'
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import toastr from 'toastr';
import Curso from './Curso';
import * as validations from '../../validations/validations';
import * as tagActions from '../../actions/tagActions';

import {  useParams } from "react-router-dom";
import { Segment} from 'semantic-ui-react'; 
import {genericFormattedForDropdown} from '../../selectors/selectors';
import moment from 'moment'; 
import $ from 'jquery';
import * as showSidebarIzquierdaActions from '../../actions/showSidebarIzquierdaActions';
 import * as infoActions from '../../actions/infoActions';
import ModalDatosInstructor from '../instructor/ModalDatosInstructor';
import {usuarioActual} from '../../util';
import * as userActions from '../../actions/userActions';
import * as cursoActions from '../../actions/cursoActions';
import * as paginaActions from '../../actions/paginaActions';
import * as menuActions from '../../actions/menuActions';
import withRouter from '../common/withRouter';

class ManageCurso extends React.Component {

    contextRef = createRef();

    constructor(props, context){
		super(props, context);
 
		this.state={
            errors:{},
            strings:[],
            permisos:{},
            modulos:[],
             curso:{
                 modulos:[],
                 aprendizaje:[]
             },
            contextRef: React.createRef(),
			tag:{
                    },
            opinion:[],
            cursos: [],
            cuponValido:{id:-1, valido:false},
            cupon:null,
            showModalInstructor:false,
            modalInstructor:{img:""}
		};
		
	}
    
    onAcordionModulo=(id)=>{
         let curso=this.state.curso;
        let modulos=curso.modulos;
        for(let i=0; i<modulos.length; i++){
            if(modulos[i].id==id){
                if(modulos[i].activo==null)
                    modulos[i].activo=true;
                else
                    modulos[i].activo=!modulos[i].activo;
            }
        }
        this.setState({"curso":curso});
    }
    
    
    componentDidMount(){
        
        let id=this.props.id;
        usuarioActual(this, "home",false);
       
        
         if(this.props.user== null){
             
            let pageInfo={
                page:"home",
                idioma:this.props.idioma
            }; 
             
            this.props.infoActions.getInfo(pageInfo).then( (paginaInfo)=>{
                    
               // this.setState({strings: paginaInfo.strings});
                
                  })
            .catch(error=>{
              toastr.error(error);
            }); 
            
        }
        
         
        this.props.showSidebarIzquierdaActions.sidebarIzquierda(false);
    
        
		
        
        if(id && id>0 ){
        this.props.infoActions.getCursoDetalleInfo(id).then( (cursoDetalle)=>{
             let modulos=cursoDetalle.modulos;
            let contenido;
            let agrupador="";
            let fecha="";
            let contenidoViewRow={};
            let contenidoView=[];
            for(let k=0; k<modulos.length; k++){
                contenidoView=[];
                contenido=modulos[k].contenido;
                agrupador="";
                fecha="";
                for(let i=0; i<contenido.length;i++){
                    if(agrupador!=contenido[i].agrupador || fecha!=contenido[i].fecha){
                        if(i>0){
                    
                            contenidoView.push(contenidoViewRow);
                        }
                        agrupador=contenido[i].agrupador;
                            fecha=contenido[i].fecha;
                        contenidoViewRow={
                            agrupador:contenido[i].agrupador,
                            fecha:contenido[i].fecha,
                            contenido:[]
                        };
                        
                        
                    }
                    contenidoViewRow.contenido.push(contenido[i]);
                     
                }
                contenidoView.push(contenidoViewRow);
                 modulos[k].contenidoView=contenidoView;
            }
            
            this.setState({"curso":cursoDetalle});  
        })
        .catch(error=>{
          toastr.error(error);
        }); 
        }
        
		
        this.props.infoActions.getCursoOpinion(id).then( (opinion)=>{
            
            this.setState({"opinion":opinion});
              
            
        })
         .catch(error=>{
          toastr.error(error);
        });
        
        
    }


    onInscribir=(tipo)=>{
        let cuponValido= this.state.cuponValido;
        //console.log("tipo:"+tipo);
        let codigo=0;
        //console.log(cuponValido.valido);
        if(cuponValido.valido==true){
            codigo=cuponValido.id;
            let porcentaje= this.state.cupon.substring(6,9);
            console.log(porcentaje);
            if(porcentaje==100){
                console.log("entro al tipo");
                tipo=1;
            }
        }
        
        this.props.cursoActions.inscribir(this.props.id, tipo, codigo, this.props.user).then( ()=>{ 
            
         if(tipo==1){    
           toastr.success("Inscripción realziada correctamente!!!.");
             this.props.navigate('/miespacio');   
        }else{
            
            toastr.success("Inscripción realziada correctamente!!! Completa el pago para tenera acceso");
            this.props.navigate('/pagolinea');
        }     
            
       }) 
        .catch(error=>{ 
          toastr.error(error); 
        });
        
    }
    
    handleChangeCupon=(event, data)=>{
    
        let cupon = data.value;
    
        if(cupon.trim().length>=12){
            cupon = cupon.substring(0, 12);
            this.setState({cupon:cupon});
            this.props.cursoActions.validarCupon(cupon,this.props.id, this.props.user).then((cuponVerificado)=>{ 
                let cuponValido = cuponVerificado;
                this.setState({cuponValido:cuponValido});
            }).catch(error=>{ 
                toastr.error(error); 
            });
            
        }else{
            this.setState({cupon:cupon});
        }
        
        
        
        
    }
    

    handleChange=(event, data)=> {

        let tag = this.state.tag;
        let field= data.name;		
        let value;
    
        if(data.type == 'radio'){
            value=	data.checked;		
        }else{
            value=	data.value;		
        }
        
        if(data.toggle){
            if(data.checked){
                value = 1;
            }else{
                 value = 2
            }
        }
        
        
        field=field.split('.');
		if(field.length==1)
      		tag[field[0]]= value;
		else{
             if(!tag[field[0]]){
                    tag[field[0]]={}
                }
			tag[field[0]][field[1]]= value;
		}
        
		
        this.setState({"tag": tag});
    }
    
    
    FormIsValid(){
        let formIsValid=true;
        let falla="";
        let errors={};
            
        let tag=this.state.tag;
              
        if(!validations.requerido(tag.tag)){
            errors.tag=true;
            formIsValid=false;
        }
        
        this.setState({
            "errors":errors
        });
        
        if(!formIsValid){
			toastr.error("Debes capturar la información requerida.");
        }
    
        return formIsValid;
    }



    onSave=(event)=>{
        event.preventDefault();
        if(!this.FormIsValid()){
            return ;
        }
       
        
        this.props.tagActions.save(this.state.tag).then(() => {
            toastr.success("Registro guardado!!!.");
            this.props.history.push('/tags');
        });
        
    }
    
     cursoPago=(id)=>{
        //console.log("Hola");
        //console.log(this.props);
        this.props.navigate('/pago/'+id);
    }
     
     
    modalInstructor=(idInstructor)=>{
        console.log(idInstructor);
        
        let showModalInstructor = this.state.showModalInstructor;
        let indexInstructores = this.state.curso.instructores.findIndex(inst=>inst.id==idInstructor); 
        let modalInstructor = this.state.curso.instructores[indexInstructores];
        showModalInstructor=true;
        this.setState({showModalInstructor:showModalInstructor,modalInstructor:modalInstructor});
        
     }
     
     onCloseModalInstructor=()=>{
        let showModalInstructor = this.state.showModalInstructor; 
        showModalInstructor=false;
        this.setState({showModalInstructor:showModalInstructor});
         
     }

       
    render() {	
         
       return (
              <div  >
                <Curso 
                    cursos={this.state.curso}
                    strings={this.props.strings}
                    id={this.props.id}
                    onChange={this.handleChange}
                    errors={this.state.errors}
                    datos={this.state.tag}
                    onSave={this.onSave}      
                    ajaxCallInProgress={this.props.ajaxCallInProgress}
                    color={this.props.color}
                    form={this.props.form}
                    permisos={this.state.permisos}
                    contextRef={this.state.contextRef}
                    modulos={this.state.modulos}
                    curso={this.state.curso}
                    onAcordionModulo={this.onAcordionModulo}
                    contextRef={this.contextRef}
                    instructores={this.state.curso.instructores}
                    opinion={this.state.opinion}
                    user={this.props.user}
                    cursoPago={this.cursoPago}
                    onInscribir={this.onInscribir}
                    onChangeCupon={this.handleChangeCupon}
                    cupon={this.state.cupon}
                    cuponValido={this.state.cuponValido}
                    onShowModalInstructor={this.modalInstructor}
                />
           
             <ModalDatosInstructor
                showModal={this.state.showModalInstructor}
                closeModal={this.onCloseModalInstructor}
                modalInstructor={this.state.modalInstructor}
            />

            </div> 
		);
	}
    
}

            
            
function mapStateToProps(state, ownProps, match ){
   
    return {        
        ajaxCallInProgress:state.ajaxCallInProgress,
        showSidebarIzquierda: state.showSidebarIzquierda,
        color:state.color,
		 permisos:state.permisos,
        form:state.form,
        instructores:state.instructores,
        user:state.user,
        strings:state.strings,
        idioma:state.idioma
    }

}

function mapDispatchToProps(dispatch){

	return { 
        userActions:bindActionCreators(userActions, dispatch),
        menuActions:bindActionCreators(menuActions, dispatch),
        infoActions: bindActionCreators(infoActions, dispatch),
        showSidebarIzquierdaActions: bindActionCreators(showSidebarIzquierdaActions, dispatch),
        paginaActions: bindActionCreators(paginaActions, dispatch),
        tagActions: bindActionCreators(tagActions, dispatch),
        cursoActions: bindActionCreators(cursoActions, dispatch)
	};
}


export default connect (mapStateToProps, mapDispatchToProps)(withRouter(ManageCurso));